var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* istanbul ignore next */
export class BaseBetsApiClient {
    constructor(configuration, ajaxService) {
        this.ajaxService = ajaxService;
        this.configuration = configuration;
    }
    getFetchOptions(request) {
        return {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.configuration.accessToken}`,
            },
            body: JSON.stringify(request || {})
        };
    }
    executeRequest(url, fetchOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            let fetchUrl = this.configuration.basePath + url;
            let options = this.getFetchOptions(fetchOptions.request);
            if (options.method === "GET" || options.method === "HEAD") {
                delete options.body;
            }
            let response = yield this.ajaxService.send(fetchUrl, options);
            if (response.status >= 200 && response.status < 300) {
                return yield response.json();
            }
            else {
                throw response;
            }
        });
    }
    refreshToken(token) {
        this.configuration.accessToken = token;
        return this;
    }
}
//# sourceMappingURL=BaseBetsApiClient.js.map